import React from 'react';
import { inject, observer, PropTypes as mobxPropTypes } from 'mobx-react';
import Form from '../../components/Form/Form';

const fields = [
  {
    id: 'oldPassword',
    name: 'oldPassword',
    label: 'Old Password',
    type: 'password',
    validateAs: 'string',
    defaultVal: '',
    required: true,
  },
  {
    id: 'newPassword',
    name: 'newPassword',
    label: 'New Password',
    type: 'password',
    validateAs: 'password',
    defaultVal: '',
    required: true,
    passwordSchema: {
      min: 8,
      matches: /(\d*[a-zA-Z]+\d*)+/,
      errorMsg: 'New Password can\'t be entirely numeric.',
    },
  },
  {
    id: 'confirmNewPassword',
    name: 'confirmNewPassword',
    label: 'Confirm Password',
    type: 'password',
    validateAs: 'confirm',
    defaultVal: '',
    required: true,
    confirmSchema: {
      compareAgainst: 'newPassword',
      errorMsg: 'Passwords don\'t match.',
    },
  },
];

const propTypes = {
  authStore: mobxPropTypes.observableObject.isRequired,
};

const ChangePasswordForm = ({ authStore }) => (
  <Form
    fields={fields}
    onSubmit={async (values, { resetForm }) => {
      try {
        await authStore.changePassword(values);
        resetForm();
      } catch (e) {
        resetForm();
      }
    }}
    submitLabel="Change Password"
    columns={3}
    spacing={32}
  />
);


ChangePasswordForm.propTypes = propTypes;
export default inject('authStore')(observer(ChangePasswordForm));



// WEBPACK FOOTER //
// ./src/containers/ChangePasswordForm/ChangePasswordForm.js